<template>
    <div class="report-leavewords">
        <div class="module-item-style report-filter-container">
            <el-date-picker
                    v-model="selectTime"
                    type="daterange"
                    @change="timeSelect"
                    :picker-options="pickerOptions"
                    range-separator="~"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd"
                    value-format="timestamp"
            >
            </el-date-picker>
            <div class="date-detail-filter">
                <div class="date-item" :class="chooseDate == index ? 'date-actived' : ''"
                     v-for="(item, index) in dateOptions"
                     :key="index" @click="chooseTime(index,item.value)">{{item.name}}
                </div>
            </div>
            <div class="report-filter-top-button">
                <div class="wl-btn" @click="exportData">导出当前数据</div>
            </div>
        </div>
        <div class="module-item-style">
            <div class="module-item-title-border-left">
                在线服务数据趋势<el-popover
                    placement="right"
                    width="400"
                    style="margin-left: 5px;vertical-align: middle;"
                    trigger="hover">
                <div style="font-size: 12px;color: #333;">默认为今日截止当前更新时间，不同时段的留言量统计</div>
                <div style="font-size: 12px;color: #333;">按条件筛选时，显示筛选条件范围内的不同时段的留言量统计</div>
                <span slot="reference"><i class="el-icon-info" ></i></span>
            </el-popover>
            </div>
            <lineChart height="380px" id="leavewords-service-trend-charts"
                       v-if="Object.keys(tendencyChartData).length > 0" :chartData="tendencyChartData"></lineChart>
        </div>
        <div class="small-chart-container">
            <div class=" publicBg">
                <p class="module-item-title-border-left">留言响应时间</p>
                <div id="leavewords-response-time-charts" style="height: 480px;width: 100%;"></div>
<!--                <pieChart height="480px" id="leavewords-response-time-charts" chartTitle="留言响应时间"-->
<!--                          v-if="Object.keys(firstRespondChartData).length > 0"-->
<!--                          :chartData="firstRespondChartData"></pieChart>-->
            </div>
            <div class=" publicBg">
                <p class="module-item-title-border-left">留言解决率</p>
                <div id="leavewords-solve-charts" style="height: 480px;width: 100%;"></div>
<!--                <pieChart height="480px" id="leavewords-solve-charts" chartTitle="留言解决率" v-if="Object.keys(leaveSolveChartData).length-->
<!--                > 0" :chartData="leaveSolveChartData"></pieChart>-->
            </div>
        </div>

    </div>
</template>

<script>
    import lineChart from '@/components/echarts/line-charts'
    import pieChart from '@/components/echarts/pie-charts'
    import echarts from "echarts";

    export default {
        name: 'report-leavewords',
        components: {
            lineChart,
            pieChart,
        },
        data() {
            return {
                chart: null,
                selectTime: '',
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now() - 8.64e6;//如果没有后面的-8.64e6就是不可以选择今天的
                    }
                },
                chooseDate: '0',
                setDate: 'lastday',
                dateOptions: [
                    {name: '昨天', value: 'lastday'},
                    {name: '上周', value: 'lastweek'},
                    {name: '上月', value: 'lastmonth'},
                ],
                startTime: '',
                endTime: '',
                tendencyChartData: {},
                leaveSolveChartData: {},
                firstRespondChartData: {},
            }
        },
        created() {
            this.initData()
        },
        mounted() {
            this.resizeCharts()
            window.addEventListener('resize', () => {
                this.resizeCharts()
            })
        },
        beforeDestroy() {
            if (!this.chart) {
                return
            }
            window.removeEventListener('resize', () => {
                this.resizeCharts()
            })
            this.chart.dispose() // 销毁
            this.chart = null
        },
        methods: {
            /**
             * 重置图表
             */
            resizeCharts() {
                setTimeout(() => {
                    if (this.chart) {
                        this.chart.resize()
                    }
                }, 350)
            },
            // 初始化饼状图表
            initPieChart() {
                this.chart = echarts.init(document.getElementById('leavewords-response-time-charts'))
                let chartData = this.firstRespondChartData
                let legendData = []
                let seriesData = []
                for (let key in chartData) {
                    legendData.push(key)
                    seriesData.push({
                        name: key,
                        value: chartData[key]
                    })
                }
                this.chart.setOption({
                    color: ['#fd6666', '#f2c900', '#63c756', '#4da3ff', '#8060fc'],
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b} : {c}%'
                    },
                    legend: {
                        left: '0',
                        top: '10',
                        orient: 'vertical',
                        data: legendData
                    },
                    series: [
                        {
                            name: this.chartTitle,
                            type: 'pie',
                            roseType: 'radius',
                            align: 'left',
                            data: seriesData,
                            animationEasing: 'cubicInOut',
                            animationDuration: 2600
                        }
                    ]
                })
            },
            // 初始化环状图表
            initCircleChart() {
                this.chart = echarts.init(document.getElementById('leavewords-solve-charts'))
                let chartData = this.leaveSolveChartData
                let legendData = []
                let seriesData = []
                for (let key in chartData) {
                    legendData.push(key)
                    seriesData.push({
                        name: key,
                        value: chartData[key]
                    })
                }
                this.chart.setOption({
                    color: ['#fd6666', '#63c756'],
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b} : {c}%'
                    },
                    legend: {
                        left: '0',
                        top: '10',
                        orient: 'vertical',
                        data: legendData
                    },
                    series: [
                        {
                            name: this.chartTitle,
                            type: 'pie',
                            roseType: 'radius',
                            align: 'left',
                            radius: ['40%', '70%'],
                            data: seriesData,
                            animationEasing: 'cubicInOut',
                            animationDuration: 2600
                        }
                    ]
                })
            },
            exportData(){
                let exportParams = {}
                if(this.setDate == ''){
                    exportParams = {
                        startTime:this.startTime,
                        endTime:this.endTime,
                    }
                }else {
                    exportParams = {
                        date:this.setDate
                    }
                }
                var params = Object.keys(exportParams).map(function (key) {
                    // body...
                    return encodeURIComponent(key) + "=" + encodeURIComponent(exportParams[key]);
                }).join("&");
                let exportUrl = process.env.VUE_APP_API_URL + '/wlapi/index/outLeaveExcel?'+params
                window.open(exportUrl)
            },
            chooseTime(index, val) {
                this.chooseDate = index
                this.setDate = val
                this.startTime = ''
                this.endTime = ''
                this.$nextTick(() => {
                    this.initData()
                })
            },
            initData() {
                this.tendencyChartData = {}
                this.leaveSolveChartData = {}
                this.firstRespondChartData = {}
                this.getLeavewordOnlineTendencyData()
                this.getLeavewordLeaveSolveData()
                this.getLeavewordFirstResponedData()
            },
            /**
             * 时间选择
             */
            timeSelect() {
                if(this.selectTime){
                    this.startTime = this.selectTime[0] / 1000
                    let endTime = this.selectTime[1] / 1000
                    this.endTime = endTime + 24 * 60 * 60 - 1
                    this.chooseDate = '-1'
                    this.setDate = ''
                }else {
                    this.startTime = ''
                    this.endTime = ''
                    this.chooseDate = '0'
                    this.setDate = 'lastday'
                }


                this.$nextTick(() => {
                    this.initData()
                })
            },
            /**
             * 折线图
             */
            getLeavewordOnlineTendencyData() {
                this.$http.getOverviewOnlineTendencyDataAPI({
                    startTime: this.startTime,
                    endTime: this.endTime,
                    date: this.setDate
                }).then(res => {
                    if (res.status == 1) {
                        let data = res.data
                        delete data.call
                        delete data.uncall
                        delete data.visitor
                        this.tendencyChartData = data
                    }

                })
            },
            /**
             * 留言解决率
             */
            getLeavewordLeaveSolveData() {
                this.$http.getOverviewLeaveSolveDataAPI({
                    startTime: this.startTime,
                    endTime: this.endTime,
                    date: this.setDate
                }).then(res => {
                    if (res.status == 1) {
                        let data = res.data
                        let newObj = {}
                        for (let key in data) {

                            if (key == 'solve') {
                                newObj['解决'] = data[key]
                            } else {
                                newObj['未解决'] = data[key]
                            }
                        }
                        // let key = Object.keys(newObj),
                        //     val = Object.values(newObj).filter(item => item === 0);
                        // if(key.length === val.length){
                        //     this.leaveSolveChartData = {}
                        // }else {
                            this.leaveSolveChartData = newObj
                            this.initCircleChart()
                        // }
                    }
                })
            },
            getLeavewordFirstResponedData(){
                this.$http.getLeavewordFirstResponedDataAPI({
                    startTime: this.startTime,
                    endTime: this.endTime,
                    date: this.setDate
                }).then( res => {
                    if (res.status == 1) {
                        let data = res.data
                        // let key = Object.keys(data),
                        //     val = Object.values(data).filter(item => item === 0);
                        // if(key.length === val.length){
                        //     this.firstRespondChartData = {}
                        // }else {
                            this.firstRespondChartData = data
                        this.initPieChart()
                        // }
                    }
                })
            }
        }
    }
</script>

<style lang="scss">

</style>
